import { render, staticRenderFns } from "./metrics_writing_skills_trajectory.vue?vue&type=template&id=893b9b6c&scoped=true&"
import script from "./metrics_writing_skills_trajectory.vue?vue&type=script&lang=js&"
export * from "./metrics_writing_skills_trajectory.vue?vue&type=script&lang=js&"
import style0 from "./metrics_writing_skills_trajectory.vue?vue&type=style&index=0&id=893b9b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893b9b6c",
  null
  
)

export default component.exports